import * as Common from './common'

$(document).ready(function () {
  if (document.body.dataset.action == 'instagram_login') {
    const ig_account_id = Common.getParam('ig_account_id');
    const ref = Common.getParam('ref')
    const insta_dm_link = "https://ig.me/m/" + ig_account_id + "?ref=" + ref;

    const STEP_INFOS_PATTERNS = [

      // A
      [{
        count_rate: 0.3,
        time_rate: 0.2
      },
      {
        count_rate: 0.35,
        time_rate: 0.2
      },
      {
        count_rate: 0.6,
        time_rate: 0.2
      },
      {
        count_rate: 0.65,
        time_rate: 0.2
      },
      {
        count_rate: 0.7,
        time_rate: 0.1
      },
      {
        count_rate: 1,
        time_rate: 0.1
      }
      ],
      // B
      [{
        count_rate: 0.03,
        time_rate: 0.125
      },
      {
        count_rate: 0.23,
        time_rate: 0.125
      },
      {
        count_rate: 0.27,
        time_rate: 0.125
      },
      {
        count_rate: 0.48,
        time_rate: 0.125
      },
      {
        count_rate: 0.55,
        time_rate: 0.125
      },
      {
        count_rate: 0.69,
        time_rate: 0.125
      },
      {
        count_rate: 0.75,
        time_rate: 0.125
      },
      {
        count_rate: 1,
        time_rate: 0.125
      }
      ],
      // C
      [{
        count_rate: 0.03,
        time_rate: 0.125
      },
      {
        count_rate: 0.18,
        time_rate: 0.125
      },
      {
        count_rate: 0.21,
        time_rate: 0.125
      },
      {
        count_rate: 0.39,
        time_rate: 0.125
      },
      {
        count_rate: 0.85,
        time_rate: 0.2
      },
      {
        count_rate: 0.95,
        time_rate: 0.125
      },
      {
        count_rate: 0.99,
        time_rate: 0.5
      },
      {
        count_rate: 1,
        time_rate: 0.125
      }
      ],
      // D
      [{
        count_rate: 0.6,
        time_rate: 0.16
      },
      {
        count_rate: 0.65,
        time_rate: 0.16
      },
      {
        count_rate: 0.68,
        time_rate: 0.16
      },
      {
        count_rate: 0.77,
        time_rate: 0.16
      },
      {
        count_rate: 0.82,
        time_rate: 0.16
      },
      {
        count_rate: 1,
        time_rate: 0.17
      }
      ]
    ]

    // 「インスタログインの準備中」のバーのアニメーションの時間
    var animationDuration = 500;

    const randomStepIndex = Math.floor(Math.random() * STEP_INFOS_PATTERNS.length);
    const randomStep = STEP_INFOS_PATTERNS[randomStepIndex];
    const progressBar = $('.instagram-dialog-text-progress-gauge-bar');

    let startTime = null;
    let progress = 0;

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const timeRatio = Math.min(elapsed / animationDuration, 1);

      const stepIndex = Math.min(Math.floor(timeRatio * randomStep.length), randomStep.length - 1);
      const stepInfo = randomStep[stepIndex];

      progress = stepInfo.count_rate * timeRatio;
      progressBar.css('width', Math.min(progress * 100, 100) + '%');

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        progressBar.css('width', '100%');
        redirectToInstaDmLink();
      }
    }
    requestAnimationFrame(animate);

    // ボタンタップでInstagramアプリのDMスレッドを開く（ユーザー操作起点なのでpopupブロック対象外）
    $('#ig-open-btn').on('click', function () {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = /android/i.test(ua);

      if (isAndroid) {
        // Androidの場合はintent://でInstagramアプリを直接指定して開く
        // App Links経由ではなくOS直接のインテントなので、Chromeシークレットモードでも動作する
        // S.browser_fallback_url: Instagramアプリが未インストールの場合はWebページにフォールバック
        const igPath = 'ig.me/m/' + ig_account_id + '?ref=' + ref;
        const fallbackUrl = encodeURIComponent(insta_dm_link);
        window.location.href = 'intent://' + igPath + '#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=' + fallbackUrl + ';end';
      } else {
        // iOS等はwindow.openでUniversal Links経由でInstagramアプリを開く
        window.open(insta_dm_link, '_blank');
      }
    });

    function redirectToInstaDmLink() {
      $('.profile-loading-instagram').hide();
      $('#ig-app-guidance').show();
    }
  }
});
